<template>
  <d-container fluid class="main-content-container h-100 px-4">
    <d-row no-gutters class="h-100">
      <d-col lg="3" md="5" class="auth-form mx-auto my-auto">
        <d-card>
          <d-card-body>
            <!-- Logo -->
            <img
              class="d-table mx-auto mb-3"
              src="@/assets/images/omja.png"
              alt="Omja Software - Login"
            />

            <!-- Title -->
            <h5 class="auth-form__title text-center mb-4">
              {{ $t("token.password.title") }}
            </h5>

            <!-- Form Fields -->
            <d-form @submit.prevent="onSubmit">
              <div class="form-group">
                <label for="exampleInputPassword1">{{
                  $t("user.password")
                }}</label>
                <d-input
                  type="password"
                  :state="errors['password'] === undefined ? null : false"
                  v-model="model.password"
                  id="exampleInputPassword1"
                  :placeholder="$t('user.password')"
                />
              </div>
              <div class="form-group mb-4">
                <label for="exampleInputPassword2">{{
                  $t("user.form.confirm.password")
                }}</label>
                <d-input
                  type="password"
                  :state="errors['password'] === undefined ? null : false"
                  v-model="repeatPassword"
                  id="exampleInputPassword2"
                  :placeholder="$t('user.password')"
                />
                <errors :errors="errors" field="password" />
              </div>
              <button
                type="submit"
                class="btn btn-pill btn-accent d-table mx-auto"
              >
                {{ $t("global.apply") }}
              </button>
            </d-form>
          </d-card-body>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import Errors from '../components/error/errors.vue';
import ErrorsHelper from '../helper/ErrorsHelper';

export default {
  name: 'changePassword',
  components: { Errors },
  data() {
    return {
      user: {},
      model: {
        token: null,
      },
      repeatPassword: '',
      requiredFields: ['password'],
      errors: {},
    };
  },
  mounted() {
    this.model.token = this.$route.params.token;
    if (!this.model.token) {
      this.$router.push('/login');
    }
    this.$services.user
      .tokenPassword(this.model)
      .then(({ data }) => {
        this.user = data;
      })
      .catch(() => {
        this.$router.push('/login');
      });
  },
  methods: {
    onSubmit() {
      this.errors = {};
      if (this.model.password !== this.repeatPassword) {
        ErrorsHelper.addError(
          this.errors,
          'password',
          this.$t('user.form.password.mismatch'),
        );
        return;
      }
      if (
        ErrorsHelper.checkErrors(this.requiredFields, this.model, this.errors)
      ) {
        this.$services.user
          .tokenPassword(this.model)
          .then(() => {
            this.$miniToastr.success(this.$t('token.password.success'));
            this.$router.push('/login');
          })
          .catch((error) => {
            console.warn('error', error);
          });
      }
    },
  },
};
</script>
